import Input from "../../../components/common/input";
import { ReactComponent as LeftArrow } from "../../../assets/icons/leftArrow.svg";
import { ReactComponent as RightArrow } from "../../../assets/icons/rightArrow.svg";
import Button from "../../../../common/components/button";
import { useSettingStore } from "../../../store/useSettingStore";
import { useState } from "react";

const SettingHeader = ({
    totalPage,
    currentPage,
    onPageChange,
}: {
    totalPage?: number;
    currentPage?: number;
    onPageChange: (page: number) => void;
}) => {
    const { selectedCategory, setSelectedCategory } = useSettingStore();
    const [inputValue, setInputValue] = useState<string>(currentPage?.toString() || "");

    const categories = ["고객", "경조사어", "상품"];

    const handlePageInput = (value: string) => {
        if (value.trim() === "") {
            setInputValue("");
            return;
        }
        if (!/^\d*$/.test(value)) {
            return;
        }
        const pageNumber = Number(value.trim());
        if (isNaN(pageNumber) || pageNumber < 1 || pageNumber > (totalPage || 1)) {
            alert("페이지 범위를 벗어났습니다.");
            setInputValue(value.slice(0, -1));
            return;
        }

        setInputValue(value);
        onPageChange(pageNumber);
    };

    return (
        <div className="flex justify-between px-3 h-[58px] items-center border-b border-gray4 w-full select-none">
            <div className="flex gap-2 items-center">
                <p className="text-2xl">관리</p>
                <RightArrow className="w-5 h-5" />
                <div className="flex p-1 rounded-lg bg-primary3">
                    {categories.map(category => (
                        <Button
                            key={category}
                            status="stress"
                            size="M"
                            className={`px-3 ${selectedCategory === category ? "bg-white text-gray2" : ""}`}
                            onClick={() => setSelectedCategory(category)}
                        >
                            {category}
                        </Button>
                    ))}
                </div>
            </div>

            <div className="flex items-center gap-2">
                <button
                    onClick={() => {
                        if (currentPage && currentPage > 1) {
                            const newPage = currentPage - 1;
                            onPageChange(newPage);
                            setInputValue(newPage.toString());
                        }
                    }}
                >
                    <LeftArrow />
                </button>
                <Input
                    inputClassName="text-center"
                    className="w-20 text-center outline-0 text-sm flex"
                    value={inputValue}
                    onChange={e => handlePageInput(e.target.value)}
                />
                <p className="text-gray3">/ {totalPage}</p>
                <button
                    onClick={() => {
                        if (currentPage && currentPage < (totalPage || 1)) {
                            const newPage = currentPage + 1;
                            onPageChange(newPage);
                            setInputValue(newPage.toString());
                        }
                    }}
                >
                    <RightArrow />
                </button>
            </div>
        </div>
    );
};

export default SettingHeader;
